function validateConfiguration(configuration) {
  var errors = [];
  console.log("Validating configuration:", configuration);
  if (configuration.AppRules?.length) {
    console.log("Validating AppRules:", configuration.AppRules);
    configuration.AppRules.forEach((rule) => {
      console.log("Validating rule:", rule);
      if (!rule.stream || rule.stream.trim() === "") {
        console.log("Stream is missing or empty for rule:", rule);
        errors.push({
          type: "error",
          message: "Stream is required for all app rules",
          closable: true,
          timeout: 10,
        });
      }
      if (!rule.version || rule.version.trim() === "") {
        errors.push({
          type: "error",
          message: "Version is required for all app rules",
          closable: true,
          timeout: 10,
        });
      }
    });
  }
  // Remove any duplicate errors by message
  errors = errors.filter(
    (error, index, self) =>
      index === self.findIndex((e) => e.message === error.message)
  );

  if (errors.length > 0) {
    return {
      valid: false,
      errors: errors,
    };
  } else {
    return {
      valid: true,
      errors: [],
    };
  }
}

module.exports = validateConfiguration;
